import { createSelector } from 'reselect';
const sessionStateSelector = (state) => state.session || {};
export const makeGetSessionState = () => createSelector(sessionStateSelector, (sessionState) => sessionState);
export const makeGetFirstName = () => createSelector(sessionStateSelector, (sessionState) => sessionState.firstName);
export const makeGetUUID = () => createSelector(sessionStateSelector, (sessionState) => sessionState.uuid);
export const makeGetIsLoggedIn = () => createSelector(sessionStateSelector, (sessionState) => Boolean(sessionState.isLoggedIn));
